import { useEffect, useState } from 'react'
import { getSidebarParam, subscribeSidebarUrlChange } from '../utils/sidebarUrl'

export function useSidebarParam(paramName: string) {
  const [paramValue, setParamValue] = useState<string | null>(() => getSidebarParam(paramName))

  useEffect(() => {
    const sync = () => {
      setParamValue(getSidebarParam(paramName))
    }

    sync()
    return subscribeSidebarUrlChange(sync)
  }, [paramName])

  return {
    paramValue,
    isOpen: paramValue !== null,
    eventId: paramValue ? parseInt(paramValue, 10) : 0
  }
}
